<script setup lang="ts">
import { defineAsyncComponent } from 'vue';

import { useAccount } from '@/composables/useAccount';
import { fade } from '@/helpers/motion';
import { settings } from '@/references/settings/globals';
import AuthView from '@/views/AuthView.vue';
const AsyncSupportChat = defineAsyncComponent(() => import('@/components/chat/SupportChat.vue'));

const { isAuthed } = useAccount();
</script>

<template>
  <div class="root-view">
    <AuthView v-if="!isAuthed" />
    <template v-else>
      <RouterView v-motion="fade" />
      <AsyncSupportChat v-if="settings.chatEnabled" />
    </template>
  </div>
</template>

<style scoped>
.root-view {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  width: 100%;
}
</style>
